import { P0, S, abs, fillAt } from '../../geometry';

export const octo = {
  name: 'Octo',
  colors: ['#8E4EC6', '#E3A008'],
  draw(m, t) {
    const dome = [
      [25, 60],
      [28, 40],
      [38, 28],
      [50, 24],
      [62, 28],
      [72, 40],
      [75, 60],
    ];
    let amp = 2.4,
      sp = 2,
      len = 1,
      splay = 0,
      pose = P0(),
      curl = false;
    if (m === 'happy') {
      amp = 5.5;
      sp = 8;
      pose.ty = -3 * abs(S(t * 6));
    }
    if (m === 'thinking') {
      amp = 2.2;
      sp = 3;
      curl = true;
      pose.rot = -4 + 2 * S(t * 1.2);
    }
    if (m === 'talking') {
      amp = 3.6;
      sp = 5;
    }
    if (m === 'surprised') {
      amp = 0.8;
      sp = 30;
      splay = 1;
      pose.ty = -3;
    }
    if (m === 'paused') {
      amp = 1.4;
      sp = 0.8;
      len = 0.6;
      pose.ty = 3;
    }
    const legs = [33, 44, 56, 67].map((bx, i) => {
      // Thinking: one tentacle taps its chin.
      if (curl && i === 3) {
        const tap = 2.4 * S(t * 7);
        return [
          [67, 62],
          [73, 70],
          [71, 79],
          [63, 78 - tap * 0.4],
          [60 + tap * 0.3, 70 - tap],
        ];
      }
      return [0, 1, 2, 3, 4].map((k) => {
        const f = k / 4;
        return [
          bx +
            amp * S(t * sp + i * 1.4 - k * 1.1) * f +
            splay * (bx - 50) * 0.55 * f,
          62 + k * 7 * len,
        ];
      });
    });
    return {
      strokes: [
        { c: 'a', pts: dome },
        ...legs.map((p) => ({ c: 'b', pts: p })),
      ],
      eyes: { x: 50, y: 48 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 0),
};
